<template>
  <nav class="navbar navbar-default" role="navigation">
      <div class="navbar-header">
          <a v-if="currentRoute != 'home'" v-on:click.prevent="historyGoBack" title="Go back" href="#" class="navbar-brand">
            <span class="back">
              <i class="fa fa-arrow-circle-left"></i>
              <span>
                Back
              </span>
            </span>
          </a>
          <a class="navbar-brand" @click="goHome">
              <span class="option">
                <i class="fa fa-file-text-o"></i>
                <span>
                  Surveys
                </span>
              </span>
          </a>
          <a class="navbar-brand" @click="goSync">
                <span class="option">
                  <i class="fa fa-cloud-upload"></i>
                  <span>
                    Synchronization
                  </span>
                </span>
          </a>
          <a class="navbar-brand" @click="goDebug">
              <span v-if="session && session.debug" class="username">
                <i class="fa fa-gear"></i>
                <span>
                  Debug Mode
                </span>
              </span>
          </a>
          <a class="navbar-brand">
            <span v-if="session && session.username" class="username">
              <i class="fa fa-user-circle"></i>
              <span>
                {{ session.username }}
              </span>
            </span>
          </a>
          <ul class="nav navbar-nav navbar-right">
            <a @click="goHome"><img src="/static/image/QualiSurveyor.svg" alt="" class="qm-logo" /></a>
          </ul>
      </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'

export default {
  name: 'Navbar',
  computed: {
    currentRoute () {
      return this.$route.name
    },
    ...mapGetters({
      session: 'getSession'
    })
  },
  methods: {
    goHome: function () {
      if (this.currentRoute === 'sync') {
        this.logout()
      }
      this.$router.push('/')
    },
    goSync: function () {
      this.$router.push('/sync')
    },
    goDebug: function () {
      this.$router.push('/debug')
    },
    historyGoBack: function () {
      if (this.currentRoute === 'sync') {
        this.logout()
      }
      this.$router.go(-1)
    },
    logout: function () {
      this.$store.dispatch('unsetToken')
      this.$store.dispatch('setUsername', '')
      this.$store.dispatch('setSudoUsername', '')
      let data = new FormData() // eslint-disable-line no-undef
      data.append('username', this.session.username)
      data.append('token', this.session.token)
      return axios.request({
        url: this.$getApiHost() + '/session/logout',
        method: 'post',
        data: {
          username: this.session.username,
          token: this.session.token
        }
      }).then((result) => {
        console.log('result', result)
      }).catch((error) => {
        this.$logException({
          error: error,
          message: 'network error on logout',
          info: { surveyor: this.session.username }
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue